<template>
  <div class="p-ability">
    <div class="p-block">
      <div class="p-block-title">
        <p class="main">{{ baseData.title }}</p>
        <p class="sub">{{ baseData.subtitle }}</p>
      </div>
    </div>
    <KdTab :navigationTab="tabList" @selected="selectedFn"></KdTab>
    <SlickCarousel
      v-for="(item, index) in baseData.tabs" :index="index" :key="index"
      className="ability"
      :baseData="item.obj"
      :class="{ hide: index !== tabIndex }"
    />
    <div class="p-block-more">
      <kd-link
        type="primary"
        @click="
          $emit('homeCallback', {
            dwClickName: 'learn_more_smart_plat',
          })
        "
      >
        <KdIcon
          icon="ArrowRightS"
          :size="24"
          fill="currentColor"
          margin="0 0 0 3px"
          leftText="点击咨询，了解更多"
          textSize="18"
        ></KdIcon>
      </kd-link>
    </div>
  </div>
</template>

<script>
import { abilityData } from './../../config.js';
import KdTab from '@/components/KdTab/index.vue';
import KdIcon from '@/components/KdIcon/index.vue';
import SlickCarousel from '@/components/SlickCarousel/index.vue';
export default {
  name: 'ability-component',
  components: { KdTab, SlickCarousel, KdIcon },
  data() {
    return {
      baseData: abilityData,
      tabList: ['基础教育', '高等教育'],
      tabIndex: 0,
    };
  },
  methods: {
    selectedFn(index) {
      this.tabIndex = Number(index);
    },
  },
};
</script>
